var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field is-expanded"},[_c('model-select',{staticClass:"input",attrs:{"options":_vm.options,"placeholder":"Select Contact Details"},model:{value:(_vm.invoice_details_id),callback:function ($$v) {_vm.invoice_details_id=$$v},expression:"invoice_details_id"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540343fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceDetailsSelect.vue
// module id = null
// module chunks = 